import appTitleBar from "./appTitleBarReducer";
import branches from "../../common/reducers/branchesReducer";
import { combineReducers } from "redux";
import errorMessage from "../../common/reducers/errorMessageReducer";
import { StoreState } from "../store/storeState";
import representatives from "./representativesReducer";
import timeSlots from "./timeSlotsReducer";
import visitCategories from "../../common/reducers/visitCategoriesReducer";
import selectedAppointmentValues from "./selectedAppointmentValuesReducer";
import appointment from "./appointmentReducer";
import authentication from "./authenticationReducer";
import appointments from "./appointmentsReducer";
import appSettings from "../../common/reducers/appSettingsReducer";
import branchHours from "./branchHoursReducer";
import customerPreferences from "./customerPreferenceReducer";
import holdTimeRemaining from "./appointmentHoldTimeRemainingReducer";
import videos from "../../common/reducers/videosReducer";
import deepLink from "./deepLinkReducer";
import deepLinkStatus from "./deepLinkStatusReducer";
import appointmentSurvey from "./appointmentSurveyReducer";
import closeAppAfterAppt from "./closeAppAfterApptReducer";

export default combineReducers<StoreState>({
  // Auth
  authentication,

  // UI
  appTitleBar,
  errorMessage,
  holdSecondsRemaining: holdTimeRemaining,
  selectedAppointmentValues,

  // Data
  appointment,
  appointments,
  appSettings,
  branches,
  branchHours,
  customerPreferences,
  availableServiceReps: representatives,
  timeSlots,
  visitCategories,
  videos,
  appointmentSurvey,

  // Deep Linking
  deepLink,
  deepLinkStatus,
  closeAppAfterAppt
});
